import 'waypoints/lib/noframework.waypoints.min';

const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      widget: '.js-search-widget',
      sticky: '.js-search-widget-sticky',
      wrapper: '.js-search-widget-wrapper',
      toggle: '.js-search-widget-toggle',
    };

    this.classes = {
      sticky: 'is-sticky',
      open: 'is-open',
    };

    if ($(this.selectors.widget).length) {
      this.init();
    }
  }

  getDOM() {
    this.DOM = {
      $widget: $(`${this.selectors.sticky} ${this.selectors.widget}`),
    };
  }

  init() {
    this.cloneForm();
    this.getDOM();
    this.initSticky();
    this.initToggle();
  }

  cloneForm() {
    const $clone = $(this.selectors.widget).clone();
    $clone.prependTo(this.selectors.sticky);
  }

  initToggle() {
    this.DOM.$widget.slideUp(0);

    $(document).on('click', this.selectors.toggle, () => {
      this.DOM.$widget.slideToggle();
      $(this.selectors.sticky).toggleClass(this.classes.open);
    });
  }

  initSticky() {
    const element = document.querySelector(this.selectors.wrapper);

    // eslint-disable-next-line no-unused-vars,no-undef
    const sticky = new Waypoint({
      element,
      handler: direction => {
        if (direction === 'down') {
          element.classList.add(this.classes.sticky);
        } else {
          element.classList.remove(this.classes.sticky);
          $(this.selectors.sticky).removeClass(this.classes.open);
          this.DOM.$widget.slideUp(0);
        }
      },
      offset() {
        return -this.element.clientHeight;
      },
    });
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/sticky-search.js